module.exports = __webpack_public_path__ + "static/media/tidal-wavePower.e9d14a4f.svg";